import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import {recordHeartbeat, webSessionHeaders} from '../auth/models/web-session.util';
import {environment} from '../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.api_token) {
            const headers: any = {
                Authorization: `Bearer ${currentUser.api_token}`
            };
            // JS-1802: tell the backend which agency this session believes it
            // is in, so stale sessions get a 409 instead of mixing pools.
            if (currentUser.agency_id) {
                headers['Active-Agency'] = String(currentUser.agency_id);
            }
            // JS-1396: this device's session. Our api only - the device token
            // is no business of other hosts.
            if (request.url.startsWith(environment.apiUrl)) {
                Object.assign(headers, webSessionHeaders());
            }
            request = request.clone({
                setHeaders: headers
            });

            // Keep Sentry user context in sync
            Sentry.setUser({
                id: currentUser.id,
                email: currentUser.email,
                api_token: currentUser.api_token,
            });
        }
        const isApiWithSession = request.url.startsWith(environment.apiUrl) && request.headers.has('X-Web-Session');
        if (!isApiWithSession) {
            return next.handle(request);
        }
        // JS-1396: a tab that is talking to the api is open - that is the
        // heartbeat (IdleLockService only pings when nothing else did).
        return next.handle(request).pipe(tap(event => {
            if (event instanceof HttpResponse) {
                recordHeartbeat(Date.now());
            }
        }));
    }
}
